import { cmd } from '@iwentsourcing/core/rpc/client/cmd.js';
import { defineRpc } from '@iwentsourcing/core/rpc/server/server.js';
import { TokenResponse } from '@iwentsourcing/core/management/authentication/token-response.js';
import { StateBrowse } from './state-browse.js';
import { BrowseItem } from './browse-item.js';
import { BrowseResult } from './browse-result.js';
import { StateGet } from './state-get.js';
import { StateIndexBrowse } from './state-index-browse.js';
import { IndexBrowseResult } from './index-browse-result.js';
import { EventPush, EventPushBatch } from './event-push.js';
import { AwaitProcessState, GetEvent, IterateEvent } from './get-event.js';
import { AuthLoginRequest } from './auth-login-request.js';
import { AuthRegisterRequest } from './auth-register-request.js';
import { AuthorizeRequest } from './authorize-request.js';
import { AuthRefresh } from './auth-refresh.js';
import { StoredEventBatch } from '@iwentsourcing/core/event-store/event-record.js';
import { nullable } from '@iwentsourcing/core/typing/nullable.js';
import { AuthTokenRequest } from './auth-token-request.js';
import { AuthDeviceCodeRequest } from './auth-device-code-request.js';
import { AuthDeviceResponse } from '@iwentsourcing/core/authentication/oauth/auth-device-response.js';
import { StoredEvent } from '@iwentsourcing/core/event-store/stored-event.js';
import { ProcessorOperationResult } from '@iwentsourcing/core/sequencer/create-state-processor.js';
import { AuthPublicProvidersRequest } from './auth-public-providers-request.js';
import { PublicAuthProvidersResponseSchema } from '@iwentsourcing/core/authentication/public-auth-providers.js';

export const loginCmd = cmd(AuthLoginRequest).returns(TokenResponse);
export const registerCmd = cmd(AuthRegisterRequest).returns(TokenResponse);
export const tokenCmd = cmd(AuthTokenRequest).returns(TokenResponse);
export const deviceCodeCmd = cmd(AuthDeviceCodeRequest).continuous(
  AuthDeviceResponse,
);
export const authorizeCmd = cmd(AuthorizeRequest).returns(TokenResponse);
export const refreshCmd = cmd(AuthRefresh).returns(TokenResponse);
export const publicProvidersCmd = cmd(AuthPublicProvidersRequest).returns(
  PublicAuthProvidersResponseSchema,
);

export const getEvent = cmd(GetEvent).returns(StoredEvent);
export const iterateEvent = cmd(IterateEvent).continuous(StoredEvent);
export const rangeEvent = cmd(IterateEvent).continuous(StoredEvent);
export const pushEvent = cmd(EventPush).returns(StoredEvent);
export const pushBatchEvent = cmd(EventPushBatch).returns(StoredEventBatch);

export const stateBrowse = cmd(StateBrowse).returns(BrowseResult);
export const stateBrowseObserve = cmd(StateBrowse).continuous(BrowseResult);
export const stateIterate = cmd(StateBrowse).continuous(BrowseItem);
export const stateGet = cmd(StateGet).returns(BrowseItem);
export const stateGetObserve = cmd(StateGet).continuous(nullable(BrowseItem));
export const stateIndexBrowse =
  cmd(StateIndexBrowse).returns(IndexBrowseResult);
export const stateIndexBrowseObserve =
  cmd(StateIndexBrowse).continuous(IndexBrowseResult);
export const stateIndexIterate = cmd(StateIndexBrowse).continuous(BrowseItem);

export const getProcessResult = cmd(GetEvent).returns(ProcessorOperationResult);
export const awaitProcessResult = cmd(AwaitProcessState);

export const rpcApiDefinition = defineRpc({
  'auth.login': loginCmd,
  'auth.register': registerCmd,
  'auth.token': tokenCmd,
  'auth.deviceCode': deviceCodeCmd,
  'auth.authorize': authorizeCmd,
  'auth.refresh': refreshCmd,
  'auth.publicProviders': publicProvidersCmd,

  'event.get': getEvent,
  //'event.iterate': iterateEvent,
  'event.range': rangeEvent,
  'event.push': pushEvent,
  'event.pushBatch': pushBatchEvent,

  'state.browse': stateBrowse,
  'state.browse.observe': stateBrowseObserve,
  'state.index.browse': stateIndexBrowse,
  'state.index.browse.observe': stateIndexBrowseObserve,
  'state.get': stateGet,
  'state.get.observe': stateGetObserve,
  'state.iterate': stateIterate,
  'state.index.iterate': stateIndexIterate,

  'process.result': getProcessResult,
  'process.await': awaitProcessResult,
});
